import { Component, OnInit } from '@angular/core';
import { BaseClass } from '../@shared/base-class/base-class';
import { IbaseService } from '../@shared/base-service/ibase-service';
import { WebserviceService } from '../@shared/services/webservice.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent extends BaseClass<any> implements OnInit {

  constructor(public service: WebserviceService, public router: Router) {
    super(document);
  }
  
  getServices(): IbaseService<any> {
    return this.service;
  }

  ngOnInit(): void {}

}